module.exports = __webpack_public_path__ + "img/GH-kyujin-top-016.578a9a3d.webp";